import { render, staticRenderFns } from "./MyOrganizHistory.vue?vue&type=template&id=36dcbc72&scoped=true&"
import script from "./MyOrganizHistory.vue?vue&type=script&lang=js&"
export * from "./MyOrganizHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dcbc72",
  null
  
)

export default component.exports